import React from 'react';
import axios from 'axios';
import moment from 'moment';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { withRouter } from 'react-router-dom';
import { actionTypes } from './reducer';
import utils from './utils';
import ModalFiles from './ModalFiles';
import ModalMove from './ModalMove';
import Pagination from './Pagination';
import CurrentFilesPath from './CurrentFilesPath';
import ModalUpload from './ModalUpload';
import ModalDownload from "./ModalDownload";

const { humanFileSize, getPathName, alertError } = utils;

const TOP_LEVEL_DOMAINS_ARR = ['abbott','abogado','ac','academy','accountant','accountants','active','actor','ad','ads','adult','ae','aero','af','afl','ag','ai','agency','airforce','al','allfinanz','alsace','am','amsterdam','an','android','ao','apartments','aq','aquarelle','ar','archi','army','arpa','as','asia','associates','at','attorney','au','auction','audio','autos','aw','ax','axa','az','ba','band','bank','bar','barclaycard','barclays','bargains','bauhaus','bayern','bb','bbc','bd','be','beer','berlin','best','bf','bg','bh','bi','bid','bike','bingo','bio','biz','bj','bl','black','blackfriday','bloomberg','blue','bm','bmw','bn','bnpparibas','bo','boats','bond','boo','boutique','bq','br','brussels','bs','bt','budapest','build','builders','business','buzz','bv','bw','by','bz','bzh','ca','cab','cafe','cal','camera','camp','cancerresearch','canon','capetown','capital','caravan','cards','care','career','careers','cartier','casa','cash','casino','cat','catering','cbn','cc','cd','center','ceo','cern','cf','cfd','cg','ch','channel','chat','cheap','chloe','christmas','chrome','church','ci','citic','city','ck','cl','claims','cleaning','click','clinic','clothing','club','cm','cn','co','coach','codes','coffee','college','cologne','com','community','company','computer','condos','construction','consulting','contractors','cooking','cool','coop','country','courses','cr','credit','creditcard','cricket','crs','cruises','cu','cuisinella','cv','cw','cx','cy','cymru','cyou','cz','dabur','dad','dance','date','dating','datsun','day','dclk','de','deals','degree','delivery','democrat','dental','dentist','desi','design','dev','diamonds','diet','digital','direct','directory','discount','dj','dk','dm','dnp','do','docs','doha','domains','doosan','download','durban','dvag','dz','eat','ec','edu','education','ee','eg','eh','email','emerck','energy','engineer','engineering','enterprises','epson','equipment','er','erni','es','esq','estate','et','eu','eurovision','eus','events','everbank','exchange','expert','exposed','express','fail','faith','fan','fans','farm','fashion','feedback','fi','film','finance','financial','firmdale','fish','fishing','fit','fitness','fj','fk','flights','florist','flowers','flsmidth','fly','fm','fo','foo','football','forex','forsale','foundation','fr','frl','frogans','fund','furniture','futbol','ga','gal','gallery','garden','gb','gbiz','gd','gdn','ge','gent','gf','gg','ggee','gh','gi','gift','gifts','gives','gl','glass','gle','global','globo','gm','gmail','gmo','gmx','gn','gold','goldpoint','golf','goo','goog','google','gop','gov','gp','gq','gr','graphics','gratis','green','gripe','gs','gt','gu','guge','guide','guitars','guru','gw','gy','hamburg','hangout','haus','healthcare','help','here','hermes','hiphop','hiv','hk','hm','hn','holdings','holiday','homes','horse','host','hosting','house','how','hr','ht','hu','ibm','id','ie','ifm','il','im','immo','immobilien','in','industries','infiniti','info','ing','ink','institute','insure','int','international','investments','io','iq','ir','irish','is','it','iwc','java','jcb','je','jetzt','jm','jo','jobs','joburg','jp','juegos','kaufen','kddi','ke','kg','kh','ki','kim','kitchen','kiwi','km','kn','koeln','komatsu','kp','kr','krd','kred','kw','ky','kyoto','kz','la','lacaixa','land','lat','latrobe','lawyer','lb','lc','lds','lease','leclerc','legal','lgbt','li','lidl','life','lighting','limited','limo','link','lk','loan','loans','london','lotte','lotto','love','lr','ls','lt','ltda','lu','luxe','luxury','lv','ly','ma','madrid','maif','maison','management','mango','market','marketing','markets','marriott','mc','md','me','media','meet','melbourne','meme','memorial','menu','mf','mg','mh','miami','mil','mini','mk','ml','mm','mma','mn','mo','mobi','moda','moe','monash','money','mormon','mortgage','moscow','motorcycles','mov','movie','mp','mq','mr','ms','mt','mtn','mtpc','mu','museum','mv','mw','mx','my','mz','na','nagoya','name','navy','nc','ne','net','network','neustar','new','news','nexus','nf','ng','ngo','nhk','ni','nico','ninja','nissan','nl','no','np','nr','nra','nrw','ntt','nu','nyc','nz','okinawa','om','one','ong','onl','online','ooo','org','organic','osaka','otsuka','ovh','pa','page','panerai','paris','partners','parts','party','pe','pf','pg','ph','pharmacy','photo','photography','photos','physio','piaget','pics','pictet','pictures','pink','pizza','pk','pl','place','plumbing','plus','pm','pn','pohl','poker','porn','post','pr','praxi','press','pro','prod','productions','prof','properties','property','ps','pt','pub','pw','py','qa','qpon','quebec','racing','re','realtor','recipes','red','redstone','rehab','reise','reisen','reit','ren','rentals','repair','report','republican','rest','restaurant','review','reviews','rich','rio','rip','ro','rocks','rodeo','rs','rsvp','ru','ruhr','rw','ryukyu','sa','saarland','sale','samsung','sap','sarl','saxo','sb','sc','sca','scb','schmidt','scholarships','school','schule','schwarz','science','scot','sd','se','services','sew','sexy','sg','sh','shiksha','shoes','shriram','si','singles','site','sj','sk','sky','sl','sm','sn','so','social','software','sohu','solar','solutions','soy','space','spiegel','spreadbetting','sr','ss','st','study','style','su','sucks','supplies','supply','support','surf','surgery','suzuki','sv','sx','sy','sydney','systems','sz','taipei','tatar','tattoo','tax','tc','td','tech','technology','tel','temasek','tennis','tf','tg','th','tickets','tienda','tips','tires','tirol','tj','tk','tl','tm','tn','to','today','tokyo','tools','top','toshiba','tours','town','toys','tp','tr','trade','trading','training','travel','trust','tt','tui','tv','tw','tz','ua','ug','uk','um','university','uno','uol','us','uy','uz','va','vacations','vc','ve','vegas','ventures','versicherung','vet','vg','vi','viajes','video','villas','vision','vlaanderen','vn','vodka','vote','voting','voto','voyage','vu','wales','wang','watch','webcam','website','wed','wedding','wf','whoswho','wien','wiki','williamhill','win','wme','work','works','world','ws','wtc','wtf','xin','рус','vermögensberater','vermögensberatung','xxx','xyz','yachts','yandex','ye','yodobashi','yoga','yokohama','youtube','yt','za','zip','zm','zone','zuerich','zw'];
const TOP_LEVEL_DOMAINS = TOP_LEVEL_DOMAINS_ARR.reduce((obj, item, index) => {
    obj[item] = index;
    return obj;
}, {});

const mapStateToProps = state => ({
    modalFilesPath: state.modalFilesPath,
    mainFilesList: state.mainFilesList
});

const mapDispatchToProps = dispatch => ({
    updateSizesInfos: (sizes, totalSize) => dispatch({
        type: actionTypes.UPDATE_SIZES_INFOS,
        payload: {
            sizes: sizes,
            totalSize: totalSize
        }
    }),
    changeModalFilesPath: newPath => dispatch({
        type: actionTypes.CHANGE_MODAL_PATH,
        payload: {
            modalFilesPath: newPath
        }
    }),
    setMainFilesList: newFilesList => dispatch({
        type: actionTypes.SET_MAIN_FILES_LIST,
        payload: {
            mainFilesList: newFilesList
        }
    })
});

export default compose(withRouter, connect(mapStateToProps, mapDispatchToProps))(class extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            currentPath: getPathName(props.location, props.match.path),
            cols: [
                { id: 'name', name: 'Name', sortAsc: false },
                { id: 'lastModified', name: 'Last modified', sortAsc: false },
                { id: 'fileSize', name: 'File size', sortAsc: false }
            ],
            filesList: 'loading',
            moreThanOneBucket: false,
            searchInput: '',
            selectedFile: '',
            fileStatus: '',
            currentPage: 1
        };

        this.forms = {
            contentTypeValue: '',
            fileNameValue: ''
        };

        this.unlisten = props.history.listen(this.changePath);
    }

    getPublicUrl = (bucketName, fileKey) => {
        const bucketEventualExtension = bucketName.split('.').pop();
        if (bucketName.indexOf('.') !== -1 && TOP_LEVEL_DOMAINS.hasOwnProperty(bucketEventualExtension)) {
            return 'https://' + bucketName + '/' + fileKey;
        }
        return 'http://' + bucketName + '.s3.amazonaws.com/' + fileKey;
    }

    changePath = location => {
        this.setState({
            currentPath: typeof(location) === 'object' ? getPathName(location, this.props.match.path) : location,
            filesList: 'loading'
        }, () => {
            if (!this.props.isInMoveModal || typeof(location) !== 'object') {
                this.refreshFilesList();
            }
        });
        if (!this.props.isInMoveModal) {
            this.props.updateSizesInfos({ document: 0, media: 0, image: 0, other: 0 }, 0);
        }
    };

    onPathChange = newPath => () => {
        // we are always in move modal when executing this func
        this.changePath(newPath + (newPath !== '/' ? '/':''));
        this.props.changeModalFilesPath(newPath + (newPath !== '/' ? '/':''));
    };

    updateFilesList = (newFilesList, onlyOneBucket) => {
        this.setState({
            filesList: newFilesList,
            moreThanOneBucket: !onlyOneBucket,
            searchInput: ''
        }, () => {
            if (this.state.currentPath === '/') {
                if (newFilesList.length === 1) {
                    this.clickOnFile(newFilesList[0])();
                }
            }
            if (!this.props.isInMoveModal) {
                this.props.setMainFilesList(newFilesList);
            }
        });
    };

    sortTable = id => () => {
        let cols = Array.from(this.state.cols);
        let index = cols.findIndex(c => c.id === id);
        cols[index].sortAsc = !cols[index].sortAsc;

        let filesList = JSON.parse(JSON.stringify(this.state.filesList));
        let sortFunc = (a, b) => {
            switch(cols[index].id) {
                case 'lastModified': return moment(a.modificationDate) > moment(b.modificationDate) ? 1:-1;
                case 'fileSize': return parseInt(a.size) > parseInt(b.size) ? 1:-1;
                case 'name': return a.name.toLowerCase() > b.name.toLowerCase() ? 1:-1;
                default: return 1;
            }
        };
        filesList.sort(sortFunc);
        if (!cols[index].sortAsc) {
            filesList.reverse();
        }

        this.setState({ cols: cols, filesList: filesList });
    };

    getFileIcon = fileType => {
        switch (fileType) {
            case 'directory': return ' zmdi-folder';
            case 'pdf': return ' zmdi-collection-pdf text-blush';
            case 'excel': return ' zmdi-chart w25 text-green';
            case 'powerpoint': return ' zmdi-file-text text-amber';
            case 'document': case 'word': return ' zmdi-file-text text-blue';
            case 'music': return ' zmdi-playlist-audio text-blue';
            case 'image': return ' zmdi-image text-purple';
            case 'video': return ' zmdi-collection-video text-blue';
            default: return ' zmdi-file-text';
        }
    };

    clickOnFile = file => () => {
        if (file.type === 'directory') {
            if (this.props.isInMoveModal) {
                this.changePath(this.state.currentPath + file.name + '/');
                this.props.changeModalFilesPath(this.state.currentPath + file.name + '/');
            } else {
                this.props.history.push(this.props.match.path + this.state.currentPath + file.name + '/');
            }
        } else {
            let relativePath = this.state.currentPath.substr(1);
            let separatedPath = relativePath.split('/');
            let bucketName = separatedPath.shift();
            let fileKey = separatedPath.join('/') + file.name;
            utils.getToken().then(token => {
                axios.post(window.API_GATEWAY_ENDPOINT + '/getFileInfos',{ bucketName: bucketName, fileKey: fileKey },
                    { headers: { Authorization: token }}).then(({ data }) => {
                    if (!data.hasOwnProperty('error')) {
                        let selectedFile = {
                            ...file,
                            filePath: this.state.currentPath,
                            publicUrl: this.getPublicUrl(bucketName, fileKey),
                            preSignedUrl: data.success.preSignedUrl,
                            contentType: data.success.contentType,
                            modifyingFileName: false,
                            renamingOnServer: false,
                            changingContentTypeOnServer: false,
                            nameAlreadyExisting: false,
                            nameEmpty: false,
                            modifyingContentType: false,
                            showPreSignedUrl: false
                        };
                        this.setState({
                            selectedFile: selectedFile
                        }, () => {
                            // eslint-disable-next-line no-undef
                            jQuery('#modalFiles').modal();
                        });
                    } else {
						let selectedFile = {
							...file,
							filePath: this.state.currentPath,
							publicUrl: this.getPublicUrl(bucketName, fileKey),
							preSignedUrl: this.getPublicUrl(bucketName, fileKey),
							contentType: utils.getMimeType(file.name),
							modifyingFileName: false,
							renamingOnServer: false,
							changingContentTypeOnServer: false,
							nameAlreadyExisting: false,
							nameEmpty: false,
							modifyingContentType: false,
							showPreSignedUrl: false
						};
						this.setState({
							selectedFile: selectedFile
						}, () => {
							// eslint-disable-next-line no-undef
							jQuery('#modalFiles').modal();
						});
					}
                });
            });
        }
    };

    renameFile = (file, newName, callback) => {
        if (file.type === 'directory') {
            alert('Can not rename directory for the moment');
        } else {
            let relativePath = this.state.selectedFile.filePath.substr(1);
            let separatedPath = relativePath.split('/');
            let bucketName = separatedPath.shift();
            let oldKey = separatedPath.join('/') + file.name;
            let newKey = separatedPath.join('/') + newName;
            if (file.name !== newName) {
                if (this.state.filesList.filter(file => file.name === newName).length === 0) {
                    this.setState({
                        selectedFile: {
                            ...file,
                            renamingOnServer: true
                        }
                    });

                    let postData = {
                        oldBucket: bucketName,
                        newBucket: bucketName,
                        oldKey: oldKey,
                        newKey: newKey,
                        copyFile: false,
                        getNewPreSignedUrl: true
                    };

                    utils.getToken().then(token => {
                        axios.post(window.API_GATEWAY_ENDPOINT + '/moveFile', postData,
                            { headers: { Authorization: token }}).then(({ data }) => {
                            if (data.hasOwnProperty('error')) {
                                console.log(postData);
                                console.log(data.error);
                                alertError('Error', 'An unexpected error occured', 'error');
                                callback({ name: file.name, modificationDate: file.modificationDate });
                            } else {
                                callback({
                                    name: newName,
                                    modificationDate: data.success.CopyObjectResult.LastModified,
                                    preSignedUrl:data.success.preSignedUrl,
                                    publicUrl: this.getPublicUrl(bucketName, newKey),
                                });
                            }
                        });
                    });
                }
            } else {
                callback({ name: newName, modificationDate: file.modificationDate });
            }
        }
    };

    goBack = () => {
        let currentPath = this.state.currentPath.split('/').filter(item => item !== '');
        currentPath.pop(); // remove last folder in path
        let newPath = '/' + currentPath.join('/') + '/';
        newPath = newPath === '//' ? newPath.substr(1) : newPath;
        if (this.props.isInMoveModal) {
            this.changePath(newPath);
            this.props.changeModalFilesPath(newPath);
        } else {
            this.props.history.push(this.props.match.path + newPath);
        }
    };

    refreshFilesList = (callback = false) => {
        if (this.state.currentPath === '/') {
            utils.getToken().then(token => {
                axios.get(window.API_GATEWAY_ENDPOINT + '/buckets',
                    { headers: { Authorization: token }}).then(({ data }) => {
                    if ('success' in data) {
                        if (callback) callback(data.success);
                        this.updateFilesList(data.success, data.success.length <= 1);
                    } else {
                        console.log(data.error);
                        this.setState({ filesList: 'error' });
                    }
                }).catch(err => {
                    console.log(err);
                    this.setState({ filesList: 'error' });
                })
            });
        } else {
            utils.getToken().then(token => {
                axios.get(window.API_GATEWAY_ENDPOINT + '/getList',
                    { params: { path: this.state.currentPath }, headers: { Authorization: token }}).then(({ data }) => {
                    if ('success' in data) {
                        let totalSize = Object.entries(data.success.sizes).map(item => item[1]).reduce((a, b) => a + b);
                        if (callback) callback(data.success.files);
                        this.updateFilesList(data.success.files, data.success.onlyOneBucket);
                        if (!this.props.isInMoveModal) {
                            this.props.updateSizesInfos(data.success.sizes, totalSize);
                        }
                    } else {
                        console.log(data.error);
                        this.setState({ filesList: 'error' });
                    }
                }).catch(err => {
                    console.log(err);
                    this.setState({ filesList: 'error' });
                })
            });
        }
    };

    editFileNameInput = () => {
        let { selectedFile } = this.state;
        if (selectedFile.modifyingFileName) {
            if (this.forms.fileNameValue !== '') {
                this.renameFile(selectedFile, this.forms.fileNameValue, result => {
                    this.setState({
                        selectedFile: {
                            ...selectedFile,
                            ...(result.hasOwnProperty('preSignedUrl') ? ({preSignedUrl: result.preSignedUrl}):({})),
                            ...(result.hasOwnProperty('publicUrl') ? ({publicUrl: result.publicUrl}):({})),
                            name: result.name,
                            modificationDate: result.modificationDate,
                            modifyingFileName: false,
                            renamingOnServer: false
                        }
                    }, this.refreshFilesList);
                });
            }
        } else {
            this.forms.fileNameValue = selectedFile.name;
            this.setState({
                selectedFile: {
                    ...selectedFile,
                    modifyingFileName: true
                }
            });
        }
    };

    changeSelectedFile = (newSelectedFile, changeCurrentPath) => {
        if (!changeCurrentPath) {
            this.setState({
                selectedFile: {
                    ...this.state.selectedFile,
                    ...newSelectedFile
                }
            }, this.refreshFilesList);
        } else {
            this.setState({
                selectedFile: {
                    ...this.state.selectedFile,
                    ...newSelectedFile
                }
            });
            this.props.history.push(this.props.match.path + newSelectedFile.filePath);
        }
    };

    editContentTypeInput = () => {
        let { selectedFile } = this.state;
        if (selectedFile.modifyingContentType) {
            if (selectedFile.contentType !== this.forms.contentTypeValue) {
                let relativePath = selectedFile.filePath.substr(1);
                let separatedPath = relativePath.split('/');
                let bucketName = separatedPath.shift();
                let key = separatedPath.join('/') + selectedFile.name;
                this.setState({
                    selectedFile: {
                        ...selectedFile,
                        changingContentTypeOnServer: true
                    }
                });
                utils.getToken().then(token => {
                    axios.post(window.API_GATEWAY_ENDPOINT + '/changeContentType', {
                        bucketName: bucketName,
                        fileKey: key,
                        contentType: this.forms.contentTypeValue
                    }, { headers: { Authorization: token }}).then(({ data }) => {
                        if (data.hasOwnProperty('error')) {
                            console.log(data.error);
                            alertError('Error', 'An unexpected error occured', 'error');
                            this.setState({
                                selectedFile: {
                                    ...selectedFile,
                                    changingContentTypeOnServer: false,
                                    modifyingContentType: false
                                }
                            });
                        } else {
                            this.setState({
                                selectedFile: {
                                    ...selectedFile,
                                    changingContentTypeOnServer: false,
                                    modifyingContentType: false,
                                    modificationDate: data.success.CopyObjectResult.LastModified,
                                    contentType: this.forms.contentTypeValue
                                }
                            }, this.refreshFilesList);
                        }
                    });
                });
            } else {
                this.setState({
                    selectedFile: {
                        ...selectedFile,
                        modifyingContentType: false
                    }
                });
            }
        } else  {
            this.forms.contentTypeValue = selectedFile.contentType;
            this.setState({
                selectedFile: {
                    ...selectedFile,
                    modifyingContentType: true
                }
            });
        }
    };

    onFileNameChange = event => {
        if (this.state.selectedFile.name !== event.target.value) {
            this.setState({
                selectedFile: {
                    ...this.state.selectedFile,
                    nameAlreadyExisting: this.state.filesList.filter(f => f.name === event.target.value).length > 0,
                    nameEmpty: event.target.value === ''
                }
            });
        }
        this.forms.fileNameValue = event.target.value;
    };

    onContentTypeChange = event => {
        this.forms.contentTypeValue = event.target.value;
    };

    showPreSignedUrl = () => {
        this.setState({
            selectedFile: {
                ...this.state.selectedFile,
                showPreSignedUrl: !this.state.selectedFile.showPreSignedUrl
            }
        });
    };

    searchInputChange = event => {
        this.setState({ searchInput: event.target.value, currentPage: 1 })
    };

    deleteFile = () => {
        let relativePath = this.state.selectedFile.filePath.substr(1);
        let separatedPath = relativePath.split('/');
        let bucketName = separatedPath.shift();
        let key = separatedPath.join('/') + this.state.selectedFile.name;
        utils.getToken().then(token => {
            axios.post(window.API_GATEWAY_ENDPOINT + '/deleteFile', {
                bucketName: bucketName,
                fileKey: key
            }, { headers: { Authorization: token }}).then(({ data }) => {
                if (data.hasOwnProperty('error')) {
                    console.log(data.error);
                    alertError('Error', 'An unexpected error occured', 'error');
                } else {
                    // eslint-disable-next-line no-undef
                    jQuery('#modalFiles').modal('hide');
                    this.refreshFilesList();
                }
            });
        });
    };

    changePageTo = (pageNumber, doNothing = false) => () => {
        if (!doNothing) {
            this.setState({
                currentPage: pageNumber
            });
        }
    };

    showModalMove = () => {
        // eslint-disable-next-line no-undef
        let modalMove = jQuery('#modalMove');
        modalMove.modal();
        // eslint-disable-next-line no-undef
        let modalHeight = jQuery('#modalFiles .modal-content').height();
        modalMove.find('.modal-content').css('min-height', modalHeight + 'px');

    };

    confirmDelete = () => {
        // eslint-disable-next-line no-undef
        const swalAlert = swal;
        swalAlert({
            title: 'Are you sure ?',
            text: 'You might not be able to recover this ' +
                (this.state.selectedFile.type === 'directory' ? 'folder':'file') + ' !',
            icon: 'warning',
            buttons: true,
            dangerMode: true,
        })
            .then(willDelete => {
                if (willDelete) {
                    this.deleteFile();
                }
            });
    };

    confirmReplace = callback => {
        // eslint-disable-next-line no-undef
        const swalAlert = swal;
        swalAlert({
            title: 'Replace file',
            text: 'A file with the same name already exists in the destination folder. ' +
                'Are you sure you want to replace the file in the destination folder ?',
            icon: 'warning',
            buttons: true,
            dangerMode: true
        })
            .then(confirmReplace => {
                if (confirmReplace) {
                    callback();
                }
            });
    };

    moveFile = copy => () => {
        const success = data => {
            if (data !== 'no move required') {
                this.props.changeSelectedFile(data, true);
            }
            // eslint-disable-next-line no-undef
            jQuery('#modalMove').modal('hide');
        };

        if (this.props.selectedFile.filePath === this.state.currentPath && !copy) {
            success('no move required');
            return;
        }

        let fileName = this.props.selectedFile.name;
        let fileNames = this.state.filesList.map(file => file.name);

        let oldRelativePath = this.props.selectedFile.filePath.substr(1);
        let oldSeparatedPath = oldRelativePath.split('/');
        let oldBucket = oldSeparatedPath.shift();
        let oldKey = oldSeparatedPath.join('/') + fileName;

        let newRelativePath = this.state.currentPath.substr(1);
        let newSeparatedPath = newRelativePath.split('/');
        let newBucket = newSeparatedPath.shift();

        let separatedWithDots = fileName.split('.');
        let fileNameWithoutExtension, extension;
        if (separatedWithDots.length > 1) {
            extension = separatedWithDots.pop();
            fileNameWithoutExtension = separatedWithDots.join('.');
        }

        if (this.props.selectedFile.filePath === this.state.currentPath) {
            while (fileNames.includes(fileNameWithoutExtension + '.' + extension)) {
                let matches = fileNameWithoutExtension.match(/copy ?([0-9]*)$/);
                if (matches === null) {
                    fileNameWithoutExtension += ' copy';
                }
                else if (matches[1] === '') {
                    fileNameWithoutExtension += ' 2';
                }
                else {
                    let n = parseInt(matches[1]);
                    fileNameWithoutExtension = fileNameWithoutExtension
                        .replace(new RegExp('copy ' + n + '$'), 'copy ' + (n + 1));
                }
            }
        }

        fileName = fileNameWithoutExtension + '.' + extension;
        let newKey = newSeparatedPath.join('/') + fileName;

        let moveOrCopyFile = () => {
            this.setState({
                fileStatus: copy ? 'copying':'moving'
            });

            let postData = {
                oldBucket: oldBucket,
                newBucket: newBucket,
                oldKey: oldKey,
                newKey: newKey,
                copyFile: copy,
                getNewPreSignedUrl: true
            };

            utils.getToken().then(token => {
                axios.post(window.API_GATEWAY_ENDPOINT + '/moveFile', postData, { headers: { Authorization: token }}).then(({data}) => {
                    if (data.hasOwnProperty('error')) {
                        console.log(postData);
                        console.log(data.error);
                        alertError('Error', 'An unexpected error occured', 'error');
                    } else {
                        success({
                            name: fileName,
                            publicUrl: this.getPublicUrl(newBucket, newKey),
                            preSignedUrl: data.success.preSignedUrl,
                            contentType: data.success.contentType,
                            filePath: '/' + newBucket + '/' + newSeparatedPath.join('/'),
                            modificationDate: data.success.CopyObjectResult.LastModified
                        });
                    }
                    this.setState({
                        fileStatus: ''
                    });
                });
            });
        };

        if (fileNames.includes(fileName)) {
            this.confirmReplace(moveOrCopyFile);
        } else {
            moveOrCopyFile();
        }
    };

    fileInfos = file => (
        <>
            <td>
                <span>
                    <i className={'w25 zmdi' + this.getFileIcon(file.type) }/>
                    { file.name }
                </span>
            </td>
            { this.props.isInMoveModal ? null:(
                <>
                    <td>
                        <span className="date">
                            {'modificationDate' in file ?
                                moment(file.modificationDate).format('DD.MM.YYYY, HH:mm'):'-'}
                        </span>
                    </td>
                    <td>
                        <span className="size">{ 'size' in file ? humanFileSize(file.size) : '-' }</span>
                    </td>
                </>
            ) }
        </>
    );

    getAllFilesComponent = () => {
        let cols = this.props.isInMoveModal ? this.state.cols.filter(col => col.id === 'name') : this.state.cols;

        return (
            <div className="tab-pane active" id="list_view">
                <div className="table-responsive">
                    <table className="table table-hover mb-0 c_table">
                        <thead>
                            <tr>
                                {cols.map((col, index) => (
                                    <th key={'th_' + index} className="clickable-th"
                                        onClick={this.sortTable(col.id)}>{col.name}
                                        <span ref={this.nameRef} className={'fooicon float-right ' +
                                        (col.sortAsc ? 'fooicon-sort-asc':'fooicon-sort-desc')}/>
                                    </th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                        { this.filesList === 'loading' ? (
                            <tr>
                                <td colSpan={cols.length} className="text-center">
                                    Loading...
                                </td>
                            </tr>
                        ): this.filesList === 'error' ? (
                           <tr>
                               <td colSpan={cols.length} className="text-center">
                                   An error occured while retrieving data.
                               </td>
                           </tr>
                        ): this.filesList.length === 0 ? (
                            <tr>
                                <td colSpan={cols.length} className="text-center">
                                    No {this.props.isInMoveModal ? 'folder':'file'} found in this folder
                                </td>
                            </tr>
                        ): this.filesList.map((file, index) => {
                            if (index >= this.filesRange.first && index <= this.filesRange.last) {
                                return (
                                    <tr key={'file_' + index} className={'file-item ' + file.type}
                                        onClick={this.clickOnFile(file)}>
                                        {this.fileInfos(file)}
                                    </tr>
                                );
                            }
                            return null;
                        })}
                        </tbody>
                    </table>
                </div>
                <div className="row">
                    <div className="ml-auto mr-auto">
                        <Pagination currentPage={this.state.currentPage}
                                    totalPages={this.totalPages}
                                    changePageTo={this.changePageTo}/>
                    </div>
                </div>
            </div>
        );
    };

    static getDerivedStateFromProps(props, state) {
        if (props.isInMoveModal && props.selectedFile.filePath === state.currentPath) {
            return {
                filesList: props.mainFilesList
            };
        }
        return null;
    }

    componentDidUpdate(prevProps) {
        if (prevProps.newFolderPrompt !== this.props.newFolderPrompt) {
            // eslint-disable-next-line no-undef
            const swalAlert = swal;
            swalAlert({
                text: 'Enter the name of your new folder',
                content: 'input',
                buttons: true,
                onOpened: (htmlElement) => {
                    // eslint-disable-next-line no-undef
                    let element = jQuery(htmlElement);
                    let input = element.find('.swal-content__input');
                    let buttonConfirm = element.find('.swal-button--confirm');
                    let folders = this.props.mainFilesList.filter(f => f.type === 'directory').map(f => f.name);

                    input.after('<div class="folder-input-error"></div>');
                    let inputError = element.find('.folder-input-error');

                    inputError.hide();
                    buttonConfirm.attr('disabled', true);

                    input.on('input', event => {
                        if (event.target.value === '') {
                            inputError.hide();
                            buttonConfirm.attr('disabled', true);
                        } else if (!folders.every(folder => folder !== event.target.value)) {
                            inputError.text('A folder with this name already exists.');
                            inputError.show();
                            buttonConfirm.attr('disabled', true);
                        } else if (event.target.value.includes('/')) {
                            inputError.text('The folder name can not contains /.');
                            inputError.show();
                            buttonConfirm.attr('disabled', true);
                        } else {
                            inputError.hide();
                            buttonConfirm.attr('disabled', false);
                        }
                    });
                    input.on('keydown', event => (event.key === 'Enter') ? buttonConfirm.trigger('click') : null);
                }
            }).then(folderName => {
                if (folderName !== null) {
                    let relativePath = this.state.currentPath.substr(1).split('/');
                    let bucketName = relativePath.shift(); // remove bucket
                    let folderCompleteName = relativePath.join('/') + folderName + '/';

                    utils.getToken().then(token => {
                        axios.post(window.API_GATEWAY_ENDPOINT + '/createFolder', {
                            bucketName: bucketName,
                            folderName: folderCompleteName
                        }, { headers: { Authorization: token }}).then(({ data }) => {
                            if (data.hasOwnProperty('error')) {
                                console.log(data.error);
                                alertError('Error', 'An unexpected error occured', 'error');
                            } else {
                                this.refreshFilesList();
                            }
                        });
                    });
                }
            });
        }
    }

    componentDidMount = () => {
        if (!this.props.isInMoveModal) {
            this.refreshFilesList();
        }
    };

    canGoBack = () => {
        if (this.state.currentPath === '/') return false;
        if (this.state.currentPath.slice(1, -1).includes('/')) return true;
        return this.state.moreThanOneBucket;
    };

    componentWillUnmount = this.unlisten;

    render() {
        this.filesList = (typeof(this.state.filesList) === 'object') ?
            this.state.filesList.filter(item =>
                (new RegExp(this.state.searchInput, 'i')).test(item.name) &&
                (this.props.isInMoveModal ? item.type === 'directory' : true)
            ) : this.state.filesList;
        this.totalPages = Math.ceil(this.filesList.length / window.ITEMS_PER_PAGE);
        // range of files to show (with pagination)
        this.filesRange = {
            first: (this.state.currentPage - 1) * window.ITEMS_PER_PAGE,
            last: (this.state.currentPage) * window.ITEMS_PER_PAGE - 1
        };
        if (this.filesRange.last > this.filesList.length) {
            this.filesRange.last = this.filesList.length - 1;
        }

        let content = (
            <div className="row clearfix">
                <div className="col-lg-12">
                    <div className="card">
                        <div className="row">
                            { this.canGoBack() ? (
                                <div className="col-auto pr-0">
                                    <div className="btn btn-danger btn-round file-back-btn mr-1"
                                         onClick={this.goBack}>
                                        <span>Back</span>
                                    </div>
                                </div>
                            ):null }
                            <div className="col mb-2">
                                <input className="form-control search-file-input"
                                       placeholder={this.props.isInMoveModal ? 'Search folder...':'Search file...'}
                                       value={this.state.searchInput}
                                       onChange={this.searchInputChange}/>
                            </div>
                        </div>
                        <div className="tab-content">
                            {this.getAllFilesComponent()}
                        </div>
                    </div>
                </div>
            </div>
        );

        return (
            <>
                { this.props.isInMoveModal ? (
                    <>
                        <div className="modal-header">
                            <div>
                                <h4 className="title">Move/copy file</h4>
                                <CurrentFilesPath path={this.state.currentPath}
                                                  onChange={this.onPathChange}
                                                  isInMoveModal/>
                            </div>
                        </div>
                        <div className="modal-body">
                            { content }
                        </div>
                        <div className="modal-footer">
                            { this.state.currentPath === '/' ? null:(
                                <>
                                    <button type="button"
                                            className="btn btn-success copy-btn waves-effect"
                                            onClick={this.moveFile(true)}>
                                        { this.state.fileStatus === 'copying' ? (
                                            <span className="spinner-border" role="status">
                                                <span className="sr-only">Loading...</span>
                                            </span>
                                        ):null }
                                        Copy here
                                    </button>
                                    <button type="button"
                                            className="btn btn-primary move-btn waves-effect"
                                            onClick={this.moveFile(false)}>
                                        { this.state.fileStatus === 'moving' ? (
                                            <span className="spinner-border" role="status">
                                                <span className="sr-only">Loading...</span>
                                            </span>
                                        ):null }
                                        Move here
                                    </button>
                                </>
                            ) }
                            <button type="button" className="btn btn-danger waves-effect" data-dismiss="modal">
                                Cancel
                            </button>
                        </div>
                    </>
                ): content }
                { this.props.isInMoveModal ? null:(
                    <>
                        <ModalUpload {...this.props} refreshFilesList={this.refreshFilesList}/>
                        <ModalDownload {...this.props} refreshFilesList={this.refreshFilesList}/>
                        <ModalFiles selectedFile={this.state.selectedFile}
                                    showPreSignedUrl={this.showPreSignedUrl}
                                    confirmDelete={this.confirmDelete}
                                    showModalMove={this.showModalMove}
                                    editFileNameInput={this.editFileNameInput}
                                    onFileNameChange={this.onFileNameChange}
                                    editContentTypeInput={this.editContentTypeInput}
                                    onContentTypeChange={this.onContentTypeChange}/>
                        <ModalMove selectedFile={this.state.selectedFile}
                                   parentFilesList={this.getParentFilesList}
                                   changeSelectedFile={this.changeSelectedFile}/>
                    </>
                )}
            </>
        );
    }
});
